function BonusApplyCtrl() {}
;
export default BonusApplyCtrl;